import React from "react";
import styles from "./text-input.module.scss";
import IComponentProps from "../../common/component-props";
import clsx from "clsx";
import { IFormField } from "../../../../utils/form-utils";

export interface ITextInputProps extends IComponentProps {
  testId: string;
  value?: string;
  name?: string;
  placeholder?: string;
  type?: React.InputHTMLAttributes<unknown>['type'];
  autoFocus?: boolean;
  readOnly?: boolean;
  field?: IFormField<string>;
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
}

export default function TextInput(props: ITextInputProps) {
  const onChange = props.field ? props.field.onChange : props.onChange;
  const onBlur = props.field ? props.field.onBlur : props.onBlur;
  const disabled = props.field ? props.field.isDisabled : props.disabled;

  return (
    <input
      data-testid={props.testId || "text-input"}
      autoFocus={props.autoFocus}
      autoComplete="off"
      type={props.type}
      name={props.name}
      readOnly={props.readOnly}
      value={props.field?.value ?? props.value ?? ""}
      onChange={(e) => { onChange(e.target.value)}}
      onBlur={(e) => { onBlur && onBlur(e.target.value)}}
      placeholder={props.placeholder}
      className={clsx(styles.input, props.className)}
      disabled={disabled}
      style={props.style}
    />
  );
}
